import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';

const MAIN_CATEGORIES = ['Carros', 'Economia', 'Mundo', 'Música', 'Politica', 'Saúde', 'Tecnologia'];

const NewsCategoriesList = ({
    newsCategories,
    getNewsCategoryIfNeeded,
    setIsMenuOpen,
    isMenuOpen,
}) => {
    const history = useHistory();
    const [otherCategories, setOtherCategories] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getNewsCategoryIfNeeded();
    }, [getNewsCategoryIfNeeded]);

    useEffect(() => {
        if (newsCategories.length > 0) {
            const filteredCategories = newsCategories.filter((category) => !MAIN_CATEGORIES.includes(category.name));

            setOtherCategories(filteredCategories);

            setIsLoading(false);
        }
    }, [newsCategories]);

    const handleCategoryChange = (option) => {
        if (option?.value && isMenuOpen) {
            const selectedSlug = option.value;

            history.push(`/noticias/${selectedSlug}`);

            setIsMenuOpen(false);

            setSelectedOption(null);
        } else {
            const selectedSlug = option.value;

            history.push(`/noticias/${selectedSlug}`);

            setSelectedOption(null);
        }
    };

    const optionsCategories = otherCategories.map((option) => ({
        value: option.slug,
        label: option.name,
    }));

    const customStyle = {
        container: (styles) => ({
            ...styles,
            width: '100%',
        }),
        control: (styles) => ({
            ...styles,
            backgroundColor: '#000',
            border: 'none',
            color: '#fff',
            boxShadow: 'none',
        }),
        valueContainer: () => ({
            padding: '2px',
            display: 'contents',
        }),
        placeholder: () => ({
            color: '#fff',
            marginLeft: 20,
            marginTop: 2,
        }),
        menu: () => ({
            marginLeft: 8,
            marginTop: 10,
            background: '#000',
            color: '#fff',
            zIndex: 9999,
        }),
        menuList: () => ({
            background: '#000',
            maxHeight: '170px',
            overflowY: 'auto',
        }),
        indicatorsContainer: () => ({
            background: '#000',
        }),
        input: () => ({
            color: 'transparent',
            caretColor: 'transparent',
        }),
        dropdownIndicator: () => ({
            marginRight: 8,
            color: '#fff',
            '&:hover': {
                color: '#ffffff',
            },
        }),
        option: (styles, { isSelected, isFocused }) => ({
            ...styles,
            height: '100%',
            width: '100%',
            backgroundColor: isSelected ? '#1E2024' : isFocused ? '#1e2024' : '#000',
            transition: 'background-color 0.2s ease',
        }),
    };

    const customStyleMobile = {
        container: (styles) => ({
            ...styles,
            width: '100%',
        }),
        control: () => ({
            border: '1px solid #000',
            color: '#000',
            boxShadow: 'none',
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
        }),
        valueContainer: () => ({
            padding: '2px',
            display: 'contents',
        }),
        placeholder: () => ({
            color: '#000',
        }),
        input: () => ({
            color: 'transparent',
            caretColor: 'transparent',
        }),
        indicatorSeparator: () => ({
            color: 'transparent',
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: '#000',
            '&:hover': {
                color: '#000',
            },
        }),
        option: (styles, { isSelected, isFocused }) => ({
            ...styles,
            height: '100%',
            width: '100%',
            backgroundColor: isSelected ? '#D0D5DD' : isFocused ? '#D0D5DD' : '#fff',
            transition: 'background-color 0.2s ease',
        }),
    };
    return (
        <div className="newsCategoriesList tw-container tw-m-0 tw-mb-0">
            <div className="newsCategoriesList__desktopShell tw-hidden md:tw-flex">
                <ul className="newsCategoriesList__desktop tw-flex tw-gap-4 tw-mb-0 tw-justify-between tw-flex-wrap">
                    {isLoading ? (
                        Array(5).fill(0).map((_, index) => (
                            <li key={index} className="tw-p-2">
                                <div className="tw-bg-gray-700 tw-w-16 tw-h-3 tw-animate-pulse tw-rounded" />
                            </li>
                        ))
                    ) : (
                        newsCategories.filter((category) => MAIN_CATEGORIES.includes(category.name)).map((category) => (
                            <li key={category.slug} className="tw-p-2">
                                <Link
                                    to={`/noticias/${category.slug}`}
                                    className="tw-text-white tw-hover:text-bluePrimary tw-transition tw-font-medium"
                                >
                                    {category.name}
                                </Link>
                            </li>
                        ))
                    )}

                    {isLoading ? (
                        <li className="">
                            <div className="tw-bg-gray-700 tw-w-32 tw-h-8 tw-animate-pulse tw-rounded" />
                        </li>
                    ) : (
                        otherCategories.length > 0 && (
                            <li className="list-category md:tw-hidden lg:tw-block lg:tw-overflow-visible">
                                <Select
                                    classNamePrefix="custom-select"
                                    value={selectedOption}
                                    onChange={(option) => {
                                        setSelectedOption(option);

                                        handleCategoryChange(option);
                                    }}
                                    options={optionsCategories}
                                    placeholder="Mais categorias"
                                    styles={customStyle}
                                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                    menuPosition="absolute"
                                    isSearchable={false}
                                />
                            </li>
                        )
                    )}

                </ul>
            </div>

            <div className="md:tw-hidden tw-flex tw-flex-col tw-gap-3 tw-mt-4 tw-pt-4 tw-border-t tw-border-[#D0D5DD]">
                <span className="tw-text-xs tw-uppercase tw-tracking-wide tw-font-semibold tw-text-gray-500">Notícias</span>

                <div className="tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-2">
                    {isLoading ? (
                        Array(5).fill(0).map((_, index) => (
                            <div key={index} className="tw-bg-gray-700 tw-w-16 tw-h-3 tw-animate-pulse tw-rounded" />
                        ))
                    ) : (
                        newsCategories.filter((category) => MAIN_CATEGORIES.includes(category.name)).map((category) => (
                            <Link
                                key={category.slug}
                                to={`/noticias/${category.slug}`}
                                className="tw-text-black tw-font-medium"
                                onClick={() => setIsMenuOpen && setIsMenuOpen(false)}
                            >
                                {category.name}
                            </Link>
                        ))
                    )}
                </div>

                <div className="tw-w-44">
                    {isLoading ? (
                        <div className="tw-bg-gray-700 tw-w-48 tw-h-10 tw-animate-pulse tw-rounded" />
                    ) : (
                        <Select
                            placeholder="Mais categorias"
                            options={optionsCategories}
                            onChange={(option) => {
                                setSelectedOption(option);

                                handleCategoryChange(option);
                            }}
                            value={selectedOption}
                            styles={customStyleMobile}
                            isSearchable={false}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

NewsCategoriesList.propTypes = exact({
    newsCategories: PropTypes.array.isRequired,
    getNewsCategoryIfNeeded: PropTypes.func.isRequired,
    setIsMenuOpen: PropTypes.func,
    isMenuOpen: PropTypes.bool,
});

export default NewsCategoriesList;
